import axios from 'axios';
import Cookies from 'js-cookie';

import { parseJson } from '@helpers/parseJson';
import { showToast } from '@helpers/showToast';

import { useAppStore } from '@store/useAppStore';

const hostname = window.location.hostname;
const hostnameAws = new URL(APP_DOMAIN_AWS).hostname;
const hostnameAzure = new URL(APP_DOMAIN_AZURE).hostname;

const token = 'Bearer ' + Cookies.get(APP_COOKIE_NAME);
const DEFAULT_ERROR_MSG = 'An error has occurred. Please try again.';
const state = useAppStore.getState();

axios.defaults.withCredentials = true;
axios.defaults.headers.common['Authorization'] = token;

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ERR_NETWORK' && !error.response?.status) {
      state.actions.setError('403');
    }
    switch (error.response?.status) {
      case 400: {
        const message = parseJson(error.response?.data?.message);

        if (message && typeof message === 'object') {
          Object.values(message as object).forEach((field) =>
            Object.values(field as object).forEach(
              (fieldMessage) => !!fieldMessage && showToast({ variant: 'error', message: fieldMessage }),
            ),
          );
        } else {
          showToast({ variant: 'error', message: message || DEFAULT_ERROR_MSG });
        }

        break;
      }
      case 401:
        window.location.href = `${APP_SSO_URL}oauth/authorize?client_id=2&response_type=token&state=${window.location.href}`;
        break;
      case 403:
        state.actions.setError('403');
        break;
      case 404:
        showToast({ variant: 'error', message: error.response?.data?.message || DEFAULT_ERROR_MSG });

        break;
      case 500:
      case 502:
        showToast({ variant: 'error', message: DEFAULT_ERROR_MSG });

        break;
    }
    return Promise.reject(error);
  },
);

export const isHostnameAws = hostname === hostnameAws;
export const isHostnameAzure = hostname === hostnameAzure;

export const apiClient: {
  get: typeof axios.get;
  post: typeof axios.post;
  delete: typeof axios.delete;
  put: typeof axios.put;
  patch: typeof axios.patch;
} = {
  get: (url, config) => axios.get(url, config),
  post: (url, data, config) => axios.post(url, data, config),
  delete: (url, config) => axios.delete(url, config),
  put: (url, config) => axios.put(url, config),
  patch: (url, data, config) => axios.patch(url, data, config),
};
